import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allUserRoutes } from '@/pages/user/routes';

export const userRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.user, action: PermissionAction.enum.view },
  },
  children: [
    ...allUserRoutes,
  ],
};
